<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <b-col cols="12" md="5" class="d-flex align-items-center justify-content-start mb-1 mb-md-0"> </b-col>
          <b-col cols="12" md="7">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="filter" class="d-inline-block mr-1" cle placeholder="Search..." />
              <b-button variant="primary" @click="addLab()">
                <span class="text-nowrap">Add Lab</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-table :outlined="true" :fields="fields" responsive="sm" class="table table-sm" :items="filteredLabs">
          <template #cell(name)="data">
            <div v-if="!data.item.editable">{{ data.value }}</div>
            <div v-else>
              <b-form-input autofocus size="sm" id="name" type="text" v-model="data.item.name"></b-form-input>
            </div>
          </template>

          <template #cell(manager)="data">
            <div v-if="!data.item.editable">{{ data.value }}</div>
            <div v-else>
              <b-form-input autofocus size="sm" id="name" type="text" v-model="data.item.manager"></b-form-input>
            </div>
          </template>
          <template #cell(email)="data">
            <div v-if="!data.item.editable">{{ data.value }}</div>
            <div v-else>
              <b-form-input autofocus size="sm" id="name" type="text" v-model="data.item.email"></b-form-input>
            </div>
          </template>


          <template #cell(actions)="data">
            <div>
              <b-button v-if="!data.item.editable" variant="primary" class="mr-25 p-50" @click="toggleEdit(data.item.id)">
                <i class="fa-solid fa-pen-to-square mr-25"></i>
                <span> Edit</span>
              </b-button>

              <b-button v-else variant="primary" class="mr-25 p-50" @click="saveEdit(data.item.id)">
                <i class="fa-solid fa-floppy-disk mr-25"></i>
                <span> Save</span>
              </b-button>

              <b-button v-if="!data.item.editable" variant="primary" @click="deleteLab(data.item.id)" class="p-50"> <i class="fa-solid fa-trash mr-25"></i> Delete </b-button>

              <b-button v-else variant="primary" @click="cancelEdit(data.item.id)" class="p-50"> <i class="fa-solid fa-xmark mr-25"></i> Cancel </b-button>
            </div>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { BOverlay, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BFormRating } from 'bootstrap-vue';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { onUnmounted } from '@vue/composition-api';
import settingsStoreModule from '../settingsStoreModule';
import vSelect from 'vue-select';

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    vSelect,
    ToastificationContent,
  },

  setup() {
    const DEPARTMENT_APP_STORE_MODULE_NAME = 'settings';
    // Register module
    if (!store.hasModule(DEPARTMENT_APP_STORE_MODULE_NAME)) store.registerModule(DEPARTMENT_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEPARTMENT_APP_STORE_MODULE_NAME)) store.unregisterModule(DEPARTMENT_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      labs: [],
      filter: null,
      loading: true,
      fields: [
        { key: 'name', sortable: true, class: 'text-left', thStyle: 'width:30%' },
        { key: 'manager', sortable: true, class: 'text-left', thStyle: 'width:25%' },
        { key: 'email', sortable: true, class: 'text-left', thStyle: 'width:25%' },
        { key: 'actions', sortable: false, class: 'text-center', thStyle: 'width:20%' },
      ],
      tempName: null,
    };
  },

  watch: {},

  methods: {
    getLabs() {
      this.loading = true;
      store
        .dispatch('settings/getAllLabs')
        .then((res) => {
          this.labs = res.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push({ name: 'settings-dashboard' });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'An error occurred',
              text: 'Please try again later or contact support.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        });
    },

    toggleEdit(id) {
      const lab = this.labs.find((dep) => dep.id === id);

      this.labs.forEach((dep) => {
        dep.editable = false;
        dep.name = dep.tempName;
      });

      if (lab) {
        lab.editable = true;
      }
    },

    cancelEdit(id) {
      this.labs = this.labs.filter((dep) => dep.id !== undefined);

      if (id !== undefined) {
        const lab = this.labs.find((dep) => dep.id === id);

        if (lab) {
          lab.name = lab.tempName;
          lab.editable = false;
        }
      }
    },

    saveEdit(id) {
      this.loading = true;
      if (id !== undefined) {
        const lab = this.labs.find((dep) => dep.id === id);

        if (lab.name != null && lab.name != '') {
          if (lab) {
            store
              .dispatch('settings/updateLab', lab)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Successful',
                    text: '✔️ Lab Update Successful',
                    icon: 'ThumbsUpIcon',
                    variant: 'success',
                  },
                });

                this.getLabs();
              })
              .catch((error) => {
                this.formShow = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'An error occurred',
                    text: 'Please try again later or contact support.',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                });
              });
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              text: 'Please fill in all fields.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.loading = false;
        }
      } else {
        const lab = this.labs.find((dep) => dep.id === undefined);

        if (lab.name != null && lab.name != '') {
          store
            .dispatch('settings/saveLab', lab)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Successful',
                  text: '✔️ Lab Add Successful',
                  icon: 'ThumbsUpIcon',
                  variant: 'success',
                },
              });

              this.getLabs();
            })
            .catch((error) => {
              this.formShow = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'An error occurred',
                  text: 'Please try again later or contact support.',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              });
            });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              text: 'Please fill in all fields.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          this.loading = false;
        }
      }
    },

    deleteLab(id) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this lab?', {
          size: 'sm',
          title: 'Confirm Deletion',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            const lab = this.labs.find((dep) => dep.id === id);

            if (lab) {
              store
                .dispatch('settings/deleteLab', lab)
                .then((response) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Successful',
                      text: '✔️ Lab Delete Successful',
                      icon: 'ThumbsUpIcon',
                      variant: 'success',
                    },
                  });

                  this.getLabs();
                })
                .catch((error) => {
                  this.formShow = false;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'An error occurred',
                      text: 'Please try again later or contact support.',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  });
                });
            }
          }
        });
    },

    addLab() {
      this.filter = null;
      this.labs = this.labs.filter((dep) => dep.id !== undefined);

      this.labs.unshift({
        name: '',
        editable: true,
      });
    },
  },

  created() {
    this.getLabs();
  },

  computed: {
    filteredLabs() {
      if (!this.filter) {
        return this.labs;
      } else {
        this.labs = this.labs.filter((dep) => dep.id !== undefined);

        this.labs.forEach((dep) => {
          dep.editable = false;
        });

        const searchTerm = this.filter.toLowerCase();
        return this.labs.filter((dep) => dep.name.toLowerCase().includes(searchTerm));
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
